import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@material-ui/core"
import { Close } from "@material-ui/icons"
import { useEffect, useState } from "react"
import { getJSONParametros } from "../../services/clientefiel"
import { pegarFaturasEmAberto } from "../../services/comum"

export const DialogAvisoFatura = () => {
    const desenvolvimento =
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("192.168")
    const parametros = JSON.parse(localStorage.getItem("custom-params"))
    const modalFatruraAberta = JSON.parse(localStorage.getItem("pop-up-fatura-aberta"))
    const idEstabelecimento = JSON.parse(localStorage.getItem("app-store"))?.state?.configuracoes
        ?.user?.parametros?.estabelecimento?.id
    const [open, setOpen] = useState(false)
    const [faturas, setFaturas] = useState([])

    const handleClick = async () => {
        try {
            const response = await pegarFaturasEmAberto(idEstabelecimento)
            setFaturas(response)
            setOpen(true)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const getParametros = async () => {
            const params = await getJSONParametros(idEstabelecimento)
            if (!params) return
            localStorage.setItem("custom-params", JSON.stringify(params))
        }
        getParametros()
    }, [])

    return (
        <>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle id="form-dialog-title">Faturas abertas</DialogTitle>
                <DialogContent>
                    {faturas.map(fatura => {
                        return (
                            <div style={{ marginBottom: "1em", width: "100%" }}>
                                <Typography>{fatura.descricao}</Typography>
                                <img
                                    width="300px"
                                    style={{ borderRadius: "20px" }}
                                    src={fatura.qrCodePix}
                                />
                                <div
                                    style={{
                                        width: "300px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginTop: "0.5em",
                                        marginBottom: "0.3em",
                                    }}
                                >
                                    <p
                                        style={{
                                            flex: 1,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            margin: 0,
                                        }}
                                    >
                                        {fatura.qrCodePixText}
                                    </p>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            navigator.clipboard
                                                .writeText(fatura.qrCodePixText)
                                                .then(() => {
                                                    console.log("Copiado com sucesso!")
                                                })
                                                .catch(err => {
                                                    console.error("Erro ao copiar:", err)
                                                })
                                        }}
                                    >
                                        Copiar
                                    </Button>
                                </div>
                                <a
                                    href={fatura.url}
                                    target="_blank"
                                    style={{
                                        textDecoration: "underline",
                                    }}
                                >
                                    Ver fatura completa
                                </a>
                                <hr />
                            </div>
                        )
                    })}
                </DialogContent>
            </Dialog>
            {!desenvolvimento &&
            (parametros?.GENERATED_ASSINATURA_STATUS === "Isenta" ||
                parametros?.GENERATED_ASSINATURA_STATUS === "Bloqueado") ? (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        color: "#fff",
                        padding: "12px 16px",
                        textAlign: "center",
                        margin: "auto",
                        zIndex: -1,
                    }}
                >
                    <Typography
                        variant="body1"
                        style={{
                            backgroundColor: "red",
                            maxWidth: "1200px",
                            padding: "0.5em",
                            margin: "auto",
                            borderRadius: "10px",
                        }}
                    >
                        Atenção, seu aplicativo está com a impressão e edição de cardápio bloqueados
                        por inadimplência .{" "}
                        <a
                            onClick={handleClick}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "white",
                                textDecoration: "underline",
                                cursor: "pointer",
                            }}
                        >
                            Clique aqui para exibir faturas em atraso e mais informações.
                        </a>
                    </Typography>
                </Box>
            ) : (
                !desenvolvimento &&
                parametros?.GENERATED_POSSUI_FATURA_ABERTA &&
                modalFatruraAberta !== false && (
                    <Box
                        id="boxFaturas"
                        sx={{
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            color: "#fff",
                            padding: "12px 16px",
                            textAlign: "center",
                            margin: "auto",
                        }}
                    >
                        <Typography
                            variant="body1"
                            style={{
                                backgroundColor: "#1EDC89",
                                width: "520px",
                                padding: "0.5em",
                                margin: "auto",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5em",
                            }}
                        >
                            <IconButton
                                size="small"
                                onClick={() => {
                                    document.getElementById("boxFaturas").style.display = "none"
                                    localStorage.setItem("pop-up-fatura-aberta", false)
                                }}
                            >
                                <Close />
                            </IconButton>
                            <div>
                                Sua fatura já foi gerada.{" "}
                                <a
                                    onClick={handleClick}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "white",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                >
                                    Clique aqui para realizar o pagamento.
                                </a>
                            </div>
                        </Typography>
                    </Box>
                )
            )}
        </>
    )
}
